import { AttachmentValue, UppyFile } from '../types';

export default function getAttachmentVariables(
  file: UppyFile,
): AttachmentValue {
  const filename = file.name;
  const key = file.meta?.s3Key ?? '';
  // Shrine expects `id` relative to the cache storage prefix.
  // Backend returns the full key (e.g. "cache/<uuid>/file.png") from /s3/presign;
  // strip the leading "cache/" so the envelope is `{ id: "<uuid>/file.png", storage: "cache" }`.
  const id = key.startsWith('cache/') ? key.slice('cache/'.length) : key;
  return {
    filename,
    file: {
      id,
      storage: 'cache',
      metadata: {
        size: file.size ?? 0,
        filename,
        mimeType: file.type ?? '',
      },
    },
    url: file.data instanceof Blob ? URL.createObjectURL(file.data) : '',
  };
}
